import { IconUser, IconBuilding, IconFileDescription, IconChecklist } from '@tabler/icons-react'

const queryTypes = [
  { icon: IconUser, label: '个人相关信息记录', desc: '身份、履历等' },
  { icon: IconBuilding, label: '企业基础信息条目', desc: '工商、资质等' },
  { icon: IconFileDescription, label: '状态类信息展示', desc: '记录、状态等' },
  { icon: IconChecklist, label: '已有信息字段核对', desc: '验证、比对等' },
]

export default function QueryTypesSection() {
  return (
    <section className="bg-gray-50 py-12">
      <div className="max-w-5xl mx-auto px-6">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">
          <div>
            <span className="text-xs font-medium text-orange-500 uppercase tracking-wider">查询范围</span>
            <h2 className="text-2xl font-bold text-gray-900 mt-2">支持的信息查询类型</h2>
          </div>
          <p className="text-xs text-gray-400">查询结果以客观信息呈现，不包含结论性内容</p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {queryTypes.map(({ icon: Icon, label, desc }, index) => (
            <div
              key={label}
              className={`group bg-white rounded-xl p-5 border border-gray-100 hover:border-orange-200 hover:shadow-md transition-all duration-300 ${index === 0 ? 'lg:col-span-1' : ''}`}
            >
              <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-orange-50 to-orange-100 flex items-center justify-center mb-4 group-hover:scale-105 transition-transform">
                <Icon size={22} className="text-orange-500" />
              </div>
              <h3 className="text-sm font-semibold text-gray-900 mb-1">{label}</h3>
              <p className="text-xs text-gray-400">{desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
